import { rowIdToLiveChartPeriod } from "@package/grid-utils";
import type { ActionContext } from "./types";

/**
 * Opens live chart in a popup window for the selected cell.
 *
 * @param targetProductId Optional product to chart instead of the selected cell's product.
 *   Used by the feed-aware submenu to plot a specific third-party feed (a `global_product` id)
 *   while keeping the selected cell's month.
 */
export const viewLiveChart = (ctx: ActionContext, targetProductId?: string): void => {
  const cell = ctx.rangeSelection?.[0];
  if (!cell) return;

  const productId = targetProductId ?? cell?.productId;
  const rowId = cell?.rowId;
  if (!productId || !rowId) return;

  const month = rowIdToLiveChartPeriod(rowId);

  window.open(
    `/app/trading-chart/${productId}/${month}`,
    "_blank",
    "width=750,height=500,menubar=no,toolbar=no,location=no,scrollbars=no,status=no",
  );
};
